const fetchImg = (name) => {
    return `https://azweuglostqaobk01.blob.core.windows.net/azqaspacebookingstorage/${name}?st=2023-05-10T15:05:24Z&se=2027-10-15T23:05:24Z&si=racwdl&spr=https&sv=2022-11-02&sr=c&sig=DYsX7NqRh86cZa0f34UCIBTv%2FQCPg9HSretSXxUb75w%3D`;
};

export default fetchImg;
